export const getIsCurrentPathWithBaseUrl = (path: string, basename: string) => {
    // Normalize paths by removing trailing slashes
    const normalizedPath = path.replace(/\/+$/, '');
    const normalizedBaseUrl = basename.replace(/\/+$/, '');
    const normalizedWindowPath = window.location.pathname.replace(/\/+$/, '');

    // Combine base URL and path, ensuring no double slashes
    const fullPath = `${normalizedBaseUrl}${normalizedPath}`;

    return normalizedWindowPath === fullPath;
};

export const getIsCurrentPath = (path: string, basename: string) => {
    return getIsCurrentPathWithBaseUrl(path, basename);
};
